<template lang="html">
    <div class="statistics_3">
        <div class="ttBar">
            <span>机构列表</span>
            <div class="timeArea">
                 <el-select class="labSelect" @change="getTab" v-model="params.code" size="small" placeholder="数据库筛选">
                    <el-option
                      v-for="item in lbSet"
                      :key="item.code"
                      :label="item.name"
                      :value="item.code">
                    </el-option>
                  </el-select>
            </div>
            <div class="timeArea inpArea">
                 <el-input v-model="params.name" @change="fancs" size="small"  suffix-icon="el-icon-search" placeholder="机构名称"></el-input>
            </div>
        </div>
        <div class="tabArea">
            <el-table
                 :data="tabDat"
                 style="width: 100%">
                 <el-table-column
                   prop="name"
                   label="机构名称"
                   width="240">

                 </el-table-column>
                 <el-table-column
                   label="姓名">
                      <template slot-scope="scope">
                           <span :class="classTrans(scope.row.code)"></span><span>{{ scope.row.code | transCode(1) }}</span>
                      </template>
                 </el-table-column>
                 <el-table-column
                   prop="address"
                   width="270"
                   align="center"
                   label="操作">
                       <template slot-scope="scope">
                            <div class="dfGroup">
                                <el-button type="primary" @click="goAnlysis(scope.row,1)" size="mini">流量分析</el-button>
                                <el-button type="warning" @click="goAnlysis(scope.row,2)" size="mini">播放统计</el-button>
                                <el-button type="danger" @click="goAnlysis(scope.row,3)" size="mini">检索统计</el-button>
                            </div>
                       </template>
                 </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
import { schoolList } from '@/api/statistics';
export default {
     data(){
        return{
            tabDat:[],
            params:{
                code:'',
                name:''
            },
            lbSet:[
                {name:'全部',code:''},
                {name:'中华民族音乐数据库',code:'LCP'},
                {name:'京剧绝版赏析数据库',code:'JBSX'},
                {name:'中华戏曲老唱片数据库',code:'XQ'},
                {name:'中华曲艺老唱片数据库',code:'QY'},
                {name:'丝绸之路上的民族音乐数据库',code:'SCZL'}
            ],
        }
     },
     watch:{
       'params.name':function(dat){
           this.getTab();
       }
     },
     filters:{
        transCode:function(dat,type){
            if(type == 1){
                 var nameMap = {
                     1:'中华民族音乐数据库',
                     3:'京剧绝版赏析数据库',
                     4:'中华戏曲老唱片数据库',
                     5:'中华曲艺老唱片数据库',
                     6:'丝绸之路上的民族音乐数据库'
                 };
                 return nameMap[dat];
            }
        }
     },
     methods:{
        getTab:function(){
            schoolList(this.params).then(response => {
                this.tabDat = response.orgManangeOrgDTOList;
            })
        },
        classTrans:function(code){
            return 'icons nameC' + code;
        },
        goAnlysis:function(rowDat,type){
            var pathUrl = '';
            if(type == 1){
                pathUrl = 'in_flow';
            }else if(type == 2){
                pathUrl = 'in_sort';
            }else if(type == 3){
                pathUrl = 'in_seek';
            }
            this.$router.push({
                path:pathUrl,
                query:{
                     anysId:rowDat.id,
                     code:rowDat.code,
                     name:rowDat.name
                }
            });
        }
     },
     created:function(){
        this.getTab();
     }
}
</script>

<style lang="scss">

.statistics_3{
    padding: 6px 12px;
    .ttBar{
         padding: 9px 12px 15px;

         border-bottom: 1px solid #e8e8e8;
         span{
             font-size: 15px;
             color: #666666;
         }

         .dateSpan{
            font-size: 14px;
            font-weight: bold;
         }

         .timeArea{
             font-size: 14px;
             color: #999999;
             margin-left: 24px;
             // margin-top: 20px;
             display: inline-block;

             .el-select{
                  // width: 90px;
             }
         }

         .inpArea{
             float: right;
             .el-input{
                  width: 360px;
             }
         }
    }
    .tabArea{
        padding: 20px;

        .icons{
            display: inline-block;
            width: 12px;
            height: 12px;
            border-radius: 12px;
            vertical-align: middle;
            margin-right: 6px;
            margin-bottom: 2px;
        }

        .dfGroup .el-button+.el-button{
            margin-left: 0px;
        }

        .nameC1{
            background: #909399;
        }
        .nameC3{
            background: #409EFF;
        }
        .nameC4{
            background: #F56C6C;
        }
        .nameC5{
            background: #E6A23C;
        }
        .nameC6{
            background: #67C23A;
        }
    }
}

</style>



// WEBPACK FOOTER //
// schoolTab.vue?031d5994